import { fetchWithAuth } from "@/providers/auth-provider";
import { ServiceResponse } from "@/types/services";
import { ClaimIdeaRewardOutput } from "types/web-app";

export const claimIdeaReward = async (accessToken: string) => {
  try {
    const response = await fetchWithAuth("/ideas/claim-reward", accessToken, {
      method: "POST",
    });
    const data =
      (await response.json()) as ServiceResponse<ClaimIdeaRewardOutput>;
    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
